import { RegistryType } from 'components/Shared/Markdown';
import { EditorialArticles } from './editorialArticles';
import { Article } from './article';
import { MostPopularProducts } from './mostPopularProducts';
import { RelatedArticles } from './relatedArtices';

const PREFIX = 'Bygghemma.Commerce.Web.src.views.EditorialPage';
export const registry = {
  [`${PREFIX}.EditorialArticlesBlock`]: EditorialArticles,
  [`${PREFIX}.EditorialMostPopularProductsBlock`]: MostPopularProducts,
  [`${PREFIX}.EditorialRelatedArticlesBlock`]: RelatedArticles,
  [`${PREFIX}.ArticleBlock`]: Article
} as RegistryType;
